import { TabView } from "@grindex-client/components/Tabs/TabView.class";
import { baseLink } from "@grindex-common/helpers/baseLink";

function init($views) {
	const ROUTES = {
		"/": "models",
		"/technology/": "technology",
		"/casestudies/": "casestudies",
		"/documentation/": "documentation",
		"*default": "models",
	};

	$views.forEach(($productTab) => {
		const tabView = new TabView(baseLink.getBaseLinkWithoutSegments(window.config.tabs), ROUTES, $productTab);

		tabView.init();
	});
}

export default {
	view: "productSeriesTabs",
	init,
};
